import * as React from "react";

const Icon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="36" height="40" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35 5V37.5893C35 38.4797 33.9239 38.9261 33.2936 38.2971L25.9135 30.9322C25.726 30.7451 25.4719 30.64 25.2071 30.64H5C2.79086 30.64 1 28.8491 1 26.64V5C1 2.79086 2.79086 1 5 1H31C33.2091 1 35 2.79086 35 5Z"
      fill="#D9D9D9"
      stroke="#D9D9D9"
      strokeWidth="2"
    />
    <circle cx="17.5" cy="16.5" r="8" stroke="#667080" />
    <path
      d="M18.2413 13.8454V22.4498H16.7394V13.8454H18.2413ZM17.4999 10.5498C17.73 10.5498 17.9281 10.6249 18.0943 10.7752C18.2647 10.9255 18.3499 11.1846 18.3499 11.5525C18.3499 11.9152 18.2647 12.1743 18.0943 12.3298C17.9281 12.48 17.73 12.5552 17.4999 12.5552C17.2613 12.5552 17.0589 12.48 16.8928 12.3298C16.7309 12.1743 16.6499 11.9152 16.6499 11.5525C16.6499 11.1846 16.7309 10.9255 16.8928 10.7752C17.0589 10.6249 17.2613 10.5498 17.4999 10.5498Z"
      fill="#667080"
    />
  </svg>
);

export default Icon;
